var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"text-message"},[[_c('p',{staticClass:"text-message-body"},[_vm._v(" "+_vm._s(_vm.body ? _vm.body : _vm.$localize('examplemessagesms'))+" ")])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }